import { Form, Spin } from 'antd';
import Box from 'components/Box';
import Empty from 'components/Empty';
import FormItemValue from 'components/Form/FormItemValue';
import { getTimeSections } from 'features/appointment/pages/AppointmentsPage/components/Calendar/TableView/Body/Modal/QuickBookingV2/helpers';
import { useMemo } from 'react';
import styled from 'styled-components';

type Props = {
  value?: string;
  onChange?: (value?: string) => void;
  onStartTimeChange?: (value?: string) => void;
};
const StartTimes = ({ value, onChange = () => undefined, onStartTimeChange = () => undefined }: Props) => {
  const form = Form.useFormInstance();
  const selectedDate = Form.useWatch(['date'], form);
  const loadingTimeSlot = Form.useWatch(['loadingTimeSlot'], form);

  const handleOnChange = (_value?: string) => {
    onChange?.(_value);
    onStartTimeChange(_value);
  };

  return (
    <>
      <Form.Item noStyle name={'loadingTimeSlot'} />
      <Form.Item noStyle name={'defaultStartTime'} />
      <FormItemValue name={'timeSlots'} render={(times) =>
        <TimeSlots loading={loadingTimeSlot} key={selectedDate?.format('YYYY-MM-DD')} value={times} dateValue={value} onChangeDate={handleOnChange} />
      } />

    </>
  );
};
StartTimes.displayName = 'QuickBookingStartTimes';
export default StartTimes;
const TimeSlots = ({ value: timeLines = [], dateValue, onChangeDate, loading }: { loading?: boolean, value?: string[], dateValue?: string, onChangeDate: (value: string) => void }) => {
  const sections = useMemo(() => getTimeSections(timeLines), [timeLines]);
  if (loading) return (
    <Box display='flex' alignItems='center' justifyContent='center'>
      <Spin spinning />
    </Box>
  );
  if (!timeLines.length) return (
    <Box display='flex' alignItems='center' justifyContent='center'>
      <Empty description='Not Available' />
    </Box>
  );
  return (
    <ContainerBox>
      {sections.morning.length > 0 && <div className='time-slot-section'>
        <div className="section-sublabel">Morning</div>
        <StartTimeChange value={dateValue} timeslots={sections.morning} onChange={onChangeDate} />
      </div>}
      {sections.afternoon.length > 0 && <div className='time-slot-section'>
        <div className="section-sublabel">Afternoon</div>
        <StartTimeChange value={dateValue} timeslots={sections.afternoon} onChange={onChangeDate} />
      </div>}
      {sections.evening.length > 0 && <div className='time-slot-section'>
        <div className="section-sublabel">Evening</div>
        <StartTimeChange value={dateValue} timeslots={sections.evening} onChange={onChangeDate} />
      </div>}
    </ContainerBox>
  );
};
const StartTimeChange = ({ value, onChange, timeslots = [] }: { value?: string, onChange?: (value: string) => void; timeslots?: string[] }) => {
  return (
    <Container>
      {timeslots.map((o: string) => (
        <button type='button' onClick={() => onChange?.(o)} key={o} className={`start-time-item ${value === o ? 'active' : ''}`}>
          <span>{o}</span>
        </button>
      ))}
    </Container>
  );
};
const ContainerBox = styled(Box)`

.time-slot-section {
  display: flex;
  padding: 8px 16px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  background: #F6F7FC;
}

.section-sublabel {
  color: #505050;
  text-align: left;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
`;
const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  align-self: stretch;
  gap: 8px;
  zoom: 0.85;
  .start-time-item {
    display: flex;
    padding: 16px 8px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 5px;
    border: 1px solid #CCD4DC;
      background: #FFF;
    span {
      color: #505050;
      text-align: center;
      font-family: Poppins;
      font-size: 22px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }

    &.active {
      border: 1px solid #2D6772;
      background: #2D6772;
      span {
        color: #FFF;
      }
    }
  }
`;